//
//
//
//

import NewDesignPressePost from "./NewDesignPressePost.vue";
import LegacyPressePost from "./LegacyPressePost.vue";

export default {
  name: "SinglePressePost",
  transition: "default",
  components: {
    NewDesignPressePost,
    LegacyPressePost,
  },
  computed: {
    pressePostComponent() {
      // Use new design if new_design is true, otherwise use legacy design
      return this.data?.attributes?.new_design
        ? "NewDesignPressePost"
        : "LegacyPressePost";
    },
  },
  async asyncData({ $axios, params, error }) {
    try {
      const qs = require("qs");
      const query = qs.stringify(
        {
          // publicationState: "preview",
          filters: {
            slug: {
              $eq: params.slug,
            },
          },
        },
        {
          encodeValuesOnly: true,
        }
      );
      // console.log("SLUG QUERY: " + query);
      var data = await $axios.$get(
        `${process.env.api_url}/api/presse-posts?${query}&populate=deep&locale=all`
      );
      // console.log("SLUG PARAMS: ", params);
      // console.log("SLUG DATA: ", data);
      
      if (!data.data.length) {
        data = false;
      }

      return { data: data.data[0] };
    } catch (err) {
      error({
        statusCode: 404,
        message: "Page not found",
      });
    }
  },
  head() {
    return {
      title: `${
        this.data.attributes.headline && this.data.attributes.headline
      }`,
      titleTemplate: "Techcast | Presse - %s",
      meta: [
        { charset: "utf-8" },
        { name: "viewport", content: "width=device-width, initial-scale=1" },
        {
          hid: "description",
          name: "description",
          content:
            this.data.attributes.page_description &&
            this.data.attributes.page_description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: `${
            this.data.attributes.title && this.data.attributes.title
          }`,
        },
        {
          hid: "og:desc",
          name: "og:description",
          content:
            this.data.attributes.page_description &&
            this.data.attributes.page_description,
        },
        {
          hid: "og:url",
          property: "og:url",
          content: `${process.env.root_url + this.$route.path}`,
        },
        // twitter card
        {
          hid: "twitter:title",
          name: "twitter:title",
          content: `${
            this.data.attributes.headline && this.data.attributes.headline
          }`,
        },
        {
          hid: "twitter:url",
          name: "twitter:url",
          content: `${process.env.root_url + this.$route.path}`,
        },
        {
          hid: "twitter:description",
          name: "twitter:description",
          content:
            this.data.attributes.page_description &&
            this.data.attributes.page_description,
        },
      ],
      link: [
        {
          hid: "canonical",
          rel: "canonical",
          href: `${process.env.root_url + this.$route.path}`,
        },
      ],
    };
  },
};
